import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Box,
  Text,
  useColorMode,
  useColorStyle,
  Divider,
} from '@tonic-one/react';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface PermissionPopoverProps {
  /**
   * Whether to show the popover
   */
  show: boolean;
  /**
   * Child element to trigger the popover
   */
  children: ReactNode;
}

/**
 * Popover component that displays "Manage trials" permission requirement
 * Shows a structured message with title, description, required permissions list, and contact info
 */
const PermissionPopover: React.FC<PermissionPopoverProps> = ({
  show,
  children,
}) => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  if (!show) {
    return <>{children}</>;
  }

  return (
    <Popover placement="bottom" trigger="hover">
      <PopoverTrigger {...{ shouldWrapChildren: true }}>
        {children}
      </PopoverTrigger>
      <PopoverContent
        PopperProps={{
          usePortal: true,
        }}
        maxWidth="360px"
        p="16px"
      >
        <Box color={colorStyle.color.primary}>
          <Text fontWeight={600} mb="8px" color={colorStyle.color.emphasis}>
            {t('welcome.permission.tooltip.title')}
          </Text>
          <Divider mb={8} />
          <Text>{t('welcome.permission.tooltip.description')}</Text>
          <Box as="ul" pl="20px" m="4px 0px">
            <Box as="li">
              <Text>
                {t('welcome.permission.tooltip.manageTrialPermission')}
              </Text>
            </Box>
          </Box>
          <Text>{t('welcome.permission.tooltip.contactAdmin')}</Text>
        </Box>
      </PopoverContent>
    </Popover>
  );
};

export default PermissionPopover;
